/**
 * @license
 * Copyright DeltaBrains. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

export const environment = {
  production: false,
  name: 'DEV',
  apiBaseUrl: 'https://api.dev.console.careconne.jp/',
  tokenUrl: 'https://api.dev2.token.ck1lab.net/',
  cKPassWebappUrl: 'https://dev2.pass.ck1lab.net/',
  domainMailSupport: 'deltabrains.vn',
  excludeOnProd: false,
};
